import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from "../views/Home.vue";
import _fun from '@/plugins/fun';
import _constapp from "@/plugins/const-es";

import { children as general } from "@/router//general.js";
import { children as security } from "@/router//security.js";
import { children as marketing } from "@/router//marketing.js";
import { children as management } from "@/router//management.js";

Vue.use(VueRouter, {
    scrollBehavior() {
        return window.scrollTo({ top: 0, behavior: 'smooth' });
    },

});
let children = [];
children.push(...general);
children.push(...security);
children.push(...marketing);
children.push(...management);


const routes = [{
        path: "*",
        redirect: "/login",
        
    },
    {
        path: "/",
        name: "HOME",
        component: Home,
        meta: {
            authenticated: true,
            breadcrumb: [{ text: "Inicio", disabled: false, href: "/#/" }],
        },
        children: children,
    },
    {
        path: "/login",
        name: "LOGIN",
        breadcrumb: [{
            text: "login",
            disabled: false,
            href: "login",
        }, ],
        component: () =>
            import ("../views/Auth/Login.vue"),
    },
    {
        path: "/account/validate/",
        name: "VALIDATE_ACCOUNT",
        breadcrumb: [{
            text: "validate",
            disabled: false,
            href: "validate",
        }, ],
        component: () =>
            import ("../views/Auth/AccountValidate.vue"),
    },
    {
        path: "/account/recovery/",
        name: "RECOVERY_ACCOUNT",
        breadcrumb: [{
            text: "recovery",
            disabled: false,
            href: "recovery",
        }, ],
        component: () =>
            import ("../views/Auth/ValidateRecoveryPassword.vue"),
    },
];


const router = new VueRouter({
    mode: "history",
    routes,
});




router.beforeEach((to, from, next) => {
    let userMenu = JSON.parse(localStorage.getItem("UserOptions"));


    let activeSession = localStorage.getItem("UsrID") != null ? true : false;
    var params = _fun.searchObject(userMenu == null ? [] : userMenu, to.name)
    const routeName = (to.name || "").toUpperCase();

    let authenticated = to.matched.some((record) => record.meta.authenticated);
    const token = localStorage.getItem("token");


    if (to.matched.some(record => record.meta.authenticated) ) {
        if (token == null) {
            next(_constapp.baseHomeURL)
            /* if(usrExtern){
                next('/login');
            }else{
                next('/micuenta');
            } */
        } 
    } 

    if (routeName != "HOME" && routeName != "LOGIN" && routeName != "VALIDATE_ACCOUNT" && routeName != "RECOVERY_ACCOUNT") {
       
        if (params !== null) {

            to.params.security = params;

            if (authenticated && !activeSession) next(_constapp.baseHomeURL);
            else if (!authenticated && activeSession) next("");
            else next();
        } 

    } else if (authenticated && !activeSession) next(_constapp.baseHomeURL);

    else if (!authenticated && activeSession) {
        next("");
    } else if (to.name.toUpperCase() == "HOME" && localStorage.getItem("UsrID") != null) {
        next();
    } else {   
        next();
    }
});

export default router;
